"use client";

// src/components/atoms/Link/Link.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var buildUrl = (href) => {
  if (typeof href === "string") return href;
  const url = new URL(href.pathname, window.location.origin);
  if (href.hash) url.hash = href.hash;
  if (href.searchParams) {
    Object.entries(href.searchParams).forEach(
      ([key, value]) => url.searchParams.append(key, value)
    );
  }
  return url.toString();
};
var Link = forwardRef(
  ({ href, children, target, ...rest }, ref) => {
    const formattedHref = buildUrl(href);
    return /* @__PURE__ */ jsx("a", { ref, href: formattedHref, target, ...rest, children });
  }
);
var Link_default = Link;

export {
  Link_default
};
